var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "touchpoint-overview-row",
    [
      _c("template", { slot: "left" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-2" }, [
            _c("i", { class: _vm.sourceBrickIcon })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-10" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.sourceBrickName))
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._l(_vm.sourceConditions, function(ref, index) {
                var operator = ref.operator
                var description = ref.description
                return _c(
                  "span",
                  { key: operator + "-" + index, staticClass: "description" },
                  [
                    _vm._v(
                      _vm._s(_vm.getOperatorName(operator)) +
                        " " +
                        _vm._s(_vm.audienceDisplayName) +
                        " " +
                        _vm._s(description)
                    )
                  ]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "center" },
        [
          _c("touchpoint-overview-icon-magic"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.connectionName))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "right" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-10" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.destinationBrickName))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(
                _vm._s(_vm.audienceDisplayName) +
                  " " +
                  _vm._s(_vm.destinationConditionDescription)
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2" }, [
            _c("i", { class: _vm.destinationBrickIcon })
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }